export const config: { [key: string]: string } = {
  apiKey: 'AIzaSyAncQciDUCDN3sLt6bWC4I6nX8va_Sejoo',
  authDomain: 'sono-portal.firebaseapp.com',
  databaseURL: 'https://sono-portal.firebaseio.com',
  projectId: 'sono-portal',
  storageBucket: 'sono-portal.appspot.com',
  messagingSenderId: '515395785221'
};
